module.exports = __webpack_public_path__ + "img/freewave1_04.f1176967.jpg";